<template>
  <basic-container>
    <avue-crud :option="option"
               v-if="reWrite"
               :table-loading="loading"
               :data="data"
               :page.sync="page"
               :permission="permissionList"
               :before-open="beforeOpen"
               :before-close="beforeClose"
               v-model="form"
               ref="crud"
               @row-update="rowUpdate"
               @row-save="rowSave"
               @row-del="rowDel"
               @search-change="searchChange"
               @search-reset="searchReset"
               @selection-change="selectionChange"
               @current-change="currentChange"
               @size-change="sizeChange"
               @refresh-change="onLoad"
               @on-load="onLoad">
      <!--<template slot="menuLeft">
        <el-button type="danger"
                   size="small"
                   icon="el-icon-delete"
                   plain
                   v-if="permission.valueclinicalevaluation_delete"
                   @click="handleDelete">删 除
        </el-button>
      </template>-->
      <template slot="projectIdSearch">
        <el-select
          v-model="projectName"
          @change="searchProjectChange"
        >
          <el-option
            v-for="item in projectList"
            :key="item"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </template>
      <template slot="fileListForm" slot-scope="scope">
        <vUpload :max="5242880" :limit="10" :fileList.sync="form.fileList" :disabled="form.flag == 'view'"></vUpload>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
  import {
    add,
    getDetail,
    getList,
    remove,
    update,
    getClinicalEvaluation,
    getPartnerList
  } from "@/api/crmedical/value/valueclinicalevaluation";
  import {mapGetters} from "vuex";
  import {getProjectList} from "@/api/crmedical/project/project";
  import dayjs from 'dayjs'
  import {getPeriodList} from "@/api/crmedical/value/valuedatareported";
  import {getAttachByMainIdList} from "@/api/crmedical/attach/attach";
  import vUpload from "@/views/components/v-upload";
  import { Base64 } from 'js-base64';
  import settings from '@/config/vd-settings';
  import { getToken } from '@/util/auth';

  export default {
    components: {
      vUpload
    },
    data() {
      return {
        projectName:'',
        form: {
          flag:'',
          attachList: [],
        },
        query: {},
        loading: true,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0
        },
        selectionList: [],
        reWrite: false,
        tempProjectId: '',
        projectList: [],
        attachIdList:[],
        fileDisabled: false,
        option: {
          height: 'auto',
          calcHeight: 50,
          tip: false,
          border: true,
          indexLabel: '序号',
          index: true,
          viewBtn: true,
          selection: true,
          columnBtn: false,
          refreshBtn: false,
          searchMenuSpan: 6,
          align: 'center',
          column: [

            {
              label: "项目名称",
              prop: "projectId",
              type: 'tree',
              labelWidth: 120,
              searchslot:true,
              span: 12,
              searchClearable: false,
              editDisabled:true,
              //cascaderItem: ['evaluationUnitId'],
              //cascaderChange: true,
              search: true,
              dicUrl: '/api/v4ward/project/getProjectList',
              props: {label: 'name', value: 'id'},
              rules: [
                {
                  required: true,
                  message: "请选择项目",
                  trigger: "change"
                }
              ]
            },
            {
              label: "周期",
              prop: "period",
              type: 'select',
              search: true,
              labelWidth: 120,
              span: 12,
              dicData: [],
              props: {
                label: 'name',
                value: 'value'
              },
              rules: [
                {
                  required: true,
                  message: "请选择周期",
                  trigger: "change"
                }
              ]
            },
            {
              label: "临床评价基数",
              prop: "clinicalEvaluationBase",
              editDisabled:true,
              addDisabled:true,
              labelWidth: 120,
              span: 12,
              rules: [
                {
                  required: true,
                  message: "请输入临床评价基数",
                  trigger: "change"
                }
              ]
            },
            {
              label: "临床评价阈值",
              prop: "clinicalEvaluationThreshold",
              editDisabled:true,
              addDisabled:true,
              labelWidth: 120,
              span: 12,
              rules: [
                {
                  required: true,
                  message: "请输入临床评价阈值",
                  trigger: "change"
                }
              ]
            },
            {
              label: "临床评价",
              prop: "clinicalEvaluation",
              labelWidth: 120,
              span: 12,
              maxlength: 5,
              max:100,
              rules: [
                {
                  required: true,
                  message: "请输入临床评值",
                  trigger: "change"
                },
                { pattern: /^(100(\.0{1,2})?)$|^([1-9]\d?(\.\d{1,2})?)$/,
                  message: '请输入100以内百分比数值',
                  trigger: "change"},
              ]
            },

            {
              label: "评价日期",
              prop: "evaluationTime",
              type: "date",
              labelWidth: 120,
              format: 'yyyy-MM-dd',
              valueFormat: 'yyyy-MM-dd 00:00:00',
              span: 12,
              rules: [
                {
                  required: true,
                  message: "请输入评价日期",
                  trigger: "change"
                }
              ]
            },

            {
              label: "填报人",
              prop: "name",
              span: 8,
              editDisplay: false,
              viewDisplay: false,
              addDisplay: false,

            },
            {
              label: "填报时间",
              prop: "createTime",
              span: 8,
              editDisplay: false,
              viewDisplay: false,
              addDisplay: false,

            },
            // {
            //   label: "评价单位",
            //   prop: "evaluationUnitId",
            //   labelWidth: 120,
            //   type: 'select',
            //   dicData: [],
            //   dataType: 'string',
            //   dicUrl: "/api/v4ward/partner/partnerlist/?id={{key}}",
            //   span: 12,
            //   props: {
            //     label: 'name',
            //     value: 'id',
            //   },
            //   rules: [
            //     {
            //       required: true,
            //       message: "请选择评价单位",
            //       trigger: "change"
            //     }
            //   ]
            // },
            {
              label: '电子附件',
              span: 24,
              labelWidth: 120,
              hide: true,
              formslot: true,
              prop: 'fileList',
            }

          ]
        },
        data: [],
        headers:{},
        viewFlag: false,
      };
    },
    computed: {
      ...
        mapGetters(["permission"]),
      permissionList() {
        return {
          addBtn: this.vaildData(this.permission.valueclinicalevaluation_add, false),
          viewBtn: this.vaildData(this.permission.valueclinicalevaluation_view, false),
          delBtn: this.vaildData(this.permission.valueclinicalevaluation_delete,false),
          editBtn: this.vaildData(this.permission.valueclinicalevaluation_edit, false)
        };
      }
      ,
      ids() {
        let ids = [];
        this.selectionList.forEach(ele => {
          ids.push(ele.id);
        });
        return ids.join(",");
      }
    },
    watch: {
      'form.projectId'() {

        //this.form.analyseSort = '';
        this.form.period = '';
        let projectIdTem = this.form.projectId;
        if (this.vdui.isNotEmpty(projectIdTem)) {
          getPeriodList({projectId: this.form.projectId}).then(({data}) => {
            if (this.operateType === 'add') {
              this.form.period = null;
            }
            const column = this.findObject(this.option.column, 'period');
            let arr = [];
            if (this.vdui.isNotEmpty(data)) {
              data.forEach(ele => {
                //ele = dayjs(ele).format('YYYY')
                let obj = {}
                obj.name = ele;
                obj.value = ele;
                arr.push(obj)
              })
              column.dicData = arr;
            } else {
              column.dicData = [{}];
            }

          });
          /*getPartnerList({id: this.form.projectId,}).then(({data}) => {
              if (this.operateType === 'add') {
                this.form.subjectId = null;
              }
              const column = this.findObject(this.option.column, 'evaluationUnitId');

              column.dicData = data;

              if (column.dicData.length == 0) {
                column.dicData.push('');
              }

            });*/
        }

      },

      'form.period'(flag) {
        let periodTem = this.form.period;
        if(this.form.flag==='add'||this.form.flag==='edit'){
          if (this.vdui.isNotEmpty(periodTem)) {
            getClinicalEvaluation({
              projectId: this.form.projectId,
              period: this.form.period,
            }).then(({data}) => {
              if (this.operateType === 'add') {
                this.form.subjectId = null;
              }
              this.form.clinicalEvaluationBase = data.clinicalEvaluationBase;
              this.form.clinicalEvaluationThreshold = data.clinicalEvaluationThreshold;

            });
          }
        }

      },
    },
    created() {
      this.headers['Authorization'] = `Basic ${Base64.encode(
        `${settings.clientId}:${settings.clientSecret}`
      )}`;
      // 让每个请求携带token--['Authorization']为自定义key 请根据实际情况自行修改
      this.headers['Blade-Auth'] = 'bearer ' + getToken();
      //加载列表
      getProjectList({}).then((res) => {
        this.projectList = res.data;
        this.projectName = this.projectList[0].name;
        this.query.projectId = this.projectList[0].id;
        getPeriodList({projectId:this.query.projectId}).then(res=>{
          const column = this.findObject(this.option.column, 'period');
          //column.dicData = res.data;
          console.log(res.data)
          let arr = [];
          if(this.vdui.isNotEmpty(res.data)){
            res.data.forEach(ele => {
              //ele = dayjs(ele).format('YYYY')
              let obj = {}
              obj.name = ele;
              obj.value = ele;
              arr.push(obj)
            })
            column.dicData = arr;
          }else {
            column.dicData=[""];
          }
        })
        if (this.projectList.length > 0) {
          this.query.projectId = this.projectList[0].id;
          //this.tempProjectId = this.projectList[0].id;
        }
        this.$nextTick(() => {
          this.reWrite = true;
        });
        //每次刷新页面时，开启房产搜索框默认显示第一个节点的名称
        //this.firstDisplayFlag = true;
      });
    },
    methods: {
      searchProjectChange(e){

        this.query.projectId = e;
        getPeriodList({projectId:e}).then(res=>{
          const column = this.findObject(this.option.column, 'period');
          //column.dicData = res.data;
          console.log(res.data)
          let arr = [];
          if(this.vdui.isNotEmpty(res.data)){
            res.data.forEach(ele => {
              //ele = dayjs(ele).format('YYYY')
              let obj = {}
              obj.name = ele;
              obj.value = ele;
              arr.push(obj)
            })
            column.dicData = arr;
          }else {
            column.dicData=[""];
          }
        })
      },
      emptyForm() {
        this.form.id='';
        this.form.projectId = '';
        this.form.period = '';
        this.form.clinicalEvaluationBase = '';
        this.form.clinicalEvaluationThreshold = '';
        this.form.clinicalEvaluation = '';
        this.form.evaluationUnitId = '';
        this.form.attachIds='';
        this.form.attachList=[];
        this.form.evaluationTime='';
        this.form.fileList=[];

      },
      /*getProjectNameById(projectId) {
        let projectName = '';
        this.projectList.forEach(function (value, index, array) {
          if (value.id === projectId) {
            projectName = value.name;
            return;
          }
        });
        return projectName;
      },*/
      rowSave(row, done, loading) {
        add(row).then(() => {
          this.emptyForm();
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
      },
      rowUpdate(row, index, done, loading) {
        update(row).then(() => {
          this.emptyForm();
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
      },
      rowDel(row) {
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: row.id});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
          });
      }
      ,
      handleDelete() {
        if (this.selectionList.length === 0) {
          this.$message.warning("请选择至少一条数据");
          return;
        }
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: this.ids});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
            this.$refs.crud.toggleSelection();
          });
      },
      beforeClose(done, type) {
        this.emptyForm();
        this.attachIdList = [];
        this.form = [];
        this.fileDisabled = false;
        done();
      },
      beforeOpen(done, type) {
        this.viewFlag = false;
        this.form.flag = type;
        if(type === 'view'){
          this.viewFlag = true;
        }
        if(type=="add"){
          this.form.fileList = [];
        }
        if (["edit", "view"].includes(type)) {

          // getAttachByMainIdList({mainId: this.form.id}).then(({data}) => {
          //   console.log(data)
          //   if (data) {
          //     data.forEach(item => {
          //       item.url = item.link;
          //       this.attachIdList.push(item.id);
          //       item.name=item.originalName;
          //     })
          //     this.form.fileList = data;
          //     console.log(this.form.fileList)
          //     this.form.attachIds = this.attachIdList.join(',');
          //   }
          // });
          if (["view"].includes(type)) {
            console.log('查看')
            this.fileDisabled = true;
          }
          setTimeout(() => {
            getDetail({id: this.form.id}).then(({data}) => {
              console.log(99999)
               this.form.period=data.period;
              this.form.fileList=data.fileList;
              // this.form.analyseSort=data.analyseSort;
              // this.form.subjectId=data.subjectId;
              // this.form.subjectName1=data.subjectName1;
             //this.form = data;
            });

          }, 0)

        }else {
          setTimeout(()=>{
            console.log(this.query.projectId);
            this.form.projectId = this.query.projectId;
          },0)
        };
        done();
      },

      searchReset() {
        //this.query.projectId=null;
        this.query.period = null;
        //this.query.projectId = this.tempProjectId;
        //this.firstDisplayFlag = true;
        this.onLoad();
      },
      searchChange(params, done) {
        params.projectId = this.query.projectId;
        params.projectName = this.query.projectName;
        this.query.period = params.period;
        this.page.currentPage = 1;
        this.onLoad();
        done();
      },
      selectionChange(list) {
        this.selectionList = list;
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
      onLoad(page) {
        page = page || this.page;
        this.loading = true;
        //如果加载列表时propertyParentId为空，则将propertyParentId置为当前的第一个房产小区
        if (!this.query.projectId) {
          this.query.projectId = this.query.projectId;
        }
        getList(
          Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
        ).then(({data}) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
          /*if (this.firstDisplayFlag) {
            let ent = document.querySelector('input[placeholder="项目名称"]');
            ent.value = this.getProjectNameById(this.query.projectId);
            this.tempProjectId = this.query.projectId
            //关闭默然显示，重刷页面时才开启默认显示
            this.firstDisplayFlag = false;
          }*/
        });
      }
    }
  };
</script>

<style>
</style>
